// relative
import { datahubIntegrationApiSlice } from '../apiSlice';

export const datahubApiSlice = datahubIntegrationApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDatahubAccountById: builder.query({
      query: (recalc_account_id) =>
        `/account?recalc_account_id=${recalc_account_id}`,
      providesTags: ['DatahubIntegrationAccount'],
      transformResponse: (response) =>
        Array.isArray(response) ? response : [response],
    }),
    getDatahubAccountByCVR: builder.query({
      query: ({ cvr_number, recalc_account_id }) =>
        `/account/${recalc_account_id}/${cvr_number}`,
      providesTags: ['DatahubIntegrationAccount'],
    }),
    postDatahubIntegrationAccount: builder.mutation({
      query: (args) => ({
        url: `/account?guard_flag=true`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: args,
      }),
      invalidatesTags: ['DatahubIntegrationAccount'],
    }),
    postDatahubIntegrationAccountRetry: builder.mutation({
      query: ({ recalc_account_id, cvr_number }) => ({
        url: `/account/${recalc_account_id}/${cvr_number}?guard_flag=true`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ['DatahubIntegrationAccount'],
    }),
    patchDatahubIntegrationAccount: builder.mutation({
      query: ({
        recalc_account_id,
        cvr_number,
        guard_flag = false,
        limited_meters_list,
        exclude_meters_list,
      }) => {
        const params = new URLSearchParams();
        if (guard_flag) params.append('guard_flag', 'true');
        if (limited_meters_list !== undefined) {
          if (
            limited_meters_list === null ||
            limited_meters_list.length === 0
          ) {
            params.append('limited_meters_list', '');
          } else {
            limited_meters_list.forEach((meter) =>
              params.append('limited_meters_list', meter),
            );
          }
        }
        if (exclude_meters_list !== undefined) {
          if (
            exclude_meters_list === null ||
            exclude_meters_list.length === 0
          ) {
            params.append('exclude_meters_list', '');
          } else {
            exclude_meters_list.forEach((meter) =>
              params.append('exclude_meters_list', meter),
            );
          }
        }
        const queryString = params.toString();
        return {
          url: `/account/${recalc_account_id}/${cvr_number}${queryString ? `?${queryString}` : ''}`,
          method: 'PATCH',
        };
      },
      invalidatesTags: (result, error) =>
        error ? [] : ['DatahubIntegrationAccount'],
    }),
    getAuthorizations: builder.query({
      query: () => '/authorizations',
      providesTags: ['DatahubAuthorizations'],
    }),
    getMeteringPointsByCvr: builder.query({
      query: (cvr_number) => `/authorizations/metering_points/${cvr_number}`,
      providesTags: ['DatahubMeteringPoints'],
    }),
    getAuthorizationsByCvr: builder.query({
      query: (cvr_number) => `/authorizations/cvr/${cvr_number}`,
      providesTags: ['DatahubAuthorizations'],
    }),
    getAuthorizationsByAccountId: builder.query({
      query: (recalc_account_id) =>
        `/authorizations/account/${recalc_account_id}`,
      providesTags: ['DatahubAuthorizations'],
    }),
    getMetersByAccount: builder.query({
      query: (recalc_account_id) => `/meters/${recalc_account_id}`,
      providesTags: ['DatahubMeters'],
    }),
  }),
});

export const {
  useGetDatahubAccountByIdQuery,
  useGetDatahubAccountByCVRQuery,
  usePostDatahubIntegrationAccountMutation,
  usePostDatahubIntegrationAccountRetryMutation,
  usePatchDatahubIntegrationAccountMutation,
  useGetAuthorizationsQuery,
  useGetMeteringPointsByCvrQuery,
  useGetAuthorizationsByCvrQuery,
  useGetAuthorizationsByAccountIdQuery,
} = datahubApiSlice;
